import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { VirtualBrand } from '~/Api/Analytics/VirtualBrand';
import { Country } from '~/Api/Country';
import { selecAnalyticaltDataSourceCountries } from '~/MedicinalBrandsAnalytics/DataSource/reducer';
import { State as RegionState } from '~/MedicinalBrandsAnalytics/Region';
import { memoizedGetDataSources } from '../AvailabilityTab/AvailabilityTabContainer';
import { VirtualBrandState } from '../reducer';

import PricesTab from './PricesTab';

const memoizedSelectDataSourceCountries = memoizeOne(selecAnalyticaltDataSourceCountries);

type State = {
	medicinalBrandsAnalyticsVirtualBrand: VirtualBrandState;
	medicinalBrandsAnalyticsRegion: RegionState;
};

type OwnProps = {
	virtualBrand: VirtualBrand;
};

function mapStateToProps(
	{ medicinalBrandsAnalyticsVirtualBrand }: State,
	props: OwnProps
): {
	countries: Country[];
} {
	const analyticVirtualBrandData =
		medicinalBrandsAnalyticsVirtualBrand.analyticsVirtualBrands?.items?.get(props.virtualBrand.id) || null;

	const dataSources = memoizedGetDataSources(analyticVirtualBrandData?.virtualPacks || null);

	return {
		countries: memoizedSelectDataSourceCountries(dataSources),
	};
}

export default connect(mapStateToProps)(PricesTab);
